<template>
  <v-card class="card-quote" elevation="0" style="min-height: 100%">
    <v-card-text>
      <v-row class="px-5">
        <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
          <!-- <v-img src="img/icons/quote_life_number.png" width="260" contain></v-img> -->
          <div
            class="d-flex flex-row align-center">
            <v-sheet
              icon
              color="title-icon"
              class="d-flex justify-center align-center rounded-circle"
              height="38"
              width="38">
              <v-icon color="title-icon-background" size="20">fas fa-users</v-icon>
            </v-sheet>
            <span
              class="title-foreground--text font-weight-medium ml-2">
              Informe o número de vidas
            </span>
          </div>
        </v-col>

        <v-col cols="2" md="3" class="component-col-header text-center"></v-col>
        <v-col cols="3" lg="2" class="component-col-header py-0 my-0 text-center">
          <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">T</p>
          <p class="py-0 my-0 text-truncate" style="font-size: 10px;">Titulares</p>
        </v-col>
        <v-col cols="3" lg="2" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
          <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">D</p>
          <p class="py-0 my-0 text-truncate" style="font-size: 10px;">Dependentes</p>
        </v-col>
        <v-col cols="3" lg="2" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
          <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">TOTAL</p>
          <p class="py-0 my-0" style="font-size: 10px;"> </p>
        </v-col>
        
        <v-col cols="12">
          <v-row v-for="(item, index) in ageIntervals" :key="index" style="height: 45px;">
            <v-col cols="2" md="3" class="component-col-age text-right px-0">
              {{ item.description }}
            </v-col>
            <v-col cols="3" lg="2" class="component-col-age pr-0 mr-0 py-0 my-0">
              <v-text-field
                :readonly="iReadOnly"
                @keydown="$util.acceptOnlyNumbers"
                :maxlength="6"
                v-model.number="item.holderCount"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3" lg="2" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
              <v-text-field
                :readonly="iReadOnly"
                @keydown="$util.acceptOnlyNumbers"
                :maxlength="6"
                v-model.number="item.dependentCount"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3" lg="2" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
              <v-text-field
                :readonly="iReadOnly"
                v-model="item.total"
                disabled
                outlined
                filled
                dense
              />
            </v-col>
            <v-col cols="1" lg="auto" class="component-col-age text-center"></v-col>
          </v-row>
        </v-col>

        <v-col cols="2" md="3" class="component-col text-right px-0">
          Total
        </v-col>
        <v-col cols="3" lg="2" class="component-col-age pr-0 mr-0 py-0 my-0">
          <v-text-field
            style="padding: 0px !important;"
            :readonly="iReadOnly"
            v-model="ageIntervalsTotal.sumHolderCount"
            disabled
            outlined
            filled
            dense
          />
        </v-col>
        <v-col cols="3" lg="2" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
          <v-text-field
            :readonly="iReadOnly"
            v-model="ageIntervalsTotal.sumDependentCount"
            disabled
            outlined
            filled
            dense
          />
        </v-col>
        <v-col cols="3" lg="2" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
          <v-text-field
            :readonly="iReadOnly"
            v-model="ageIntervalsTotal.sumTotal"
            disabled
            outlined
            filled
            dense
          />
        </v-col>
        <v-col cols="1" lg="auto" class="component-col-header text-center"></v-col>
        
      </v-row>
    </v-card-text>

    <v-dialog
      v-model="showDialog"
      persistent
      scrollable
      max-width="600">
      <v-card>
        <v-card-subtitle style="color: var(--v-primary-base); box-shadow: 1px 1px 5px 3px color-mix(in srgb, var(--v-shadow-base) 50%, transparent);">
          <v-row class="mt-2">
            <v-col cols="12" class="text-center">
              <span v-if="msgDialogType === 'INFORMATION'">Informe a idade dos usuários com 59 anos ou mais.</span>
              <v-alert v-else-if="msgDialogType === 'EMPTY'" dense outlined type="error">
                Por favor, preencha todos os campos.
              </v-alert>
              <v-alert v-else-if="msgDialogType === 'AGE'" dense outlined type="error">
                A idade deve ser maior ou igual a 59 anos.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text class="pt-5" style="min-height: 100px !important; max-height: 650px !important;">
          <v-row class="py-0 my-0" v-for="(item, index) in getCountLifesFromDialog" :key="index">
            <v-col cols="4" md="5" class="component-col-age text-truncate text-right py-0 my-0 pt-md-2">
              {{ item.description }}
            </v-col>
            <v-col cols="4" md="2" class="component-col-age pr-md-0 mr-md-0 py-0 my-0">
              <v-text-field
                @keydown="$util.acceptOnlyNumbers"
                :maxlength="3"
                v-model.number="item.age"
                outlined
                dense
              />
            </v-col>
            <v-col cols="4" md="5" class="component-col-header text-center py-0 my-0"></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-quote"
            large
            width="130"
            @click="cancelDialog()">
            <v-icon left>fas fa-times</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            class="btn-quote"
            large
            width="130"
            @click="confirmDialog()">
            <v-icon left>fas fa-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {mapActions, mapMutations} from "vuex";

export default {
  name: 'juridicalPersonLifeCount',
  data: () => ({
    iReadOnly: false,
    quoteSessionKey: 'quoteDataObj',
    msgDialogType: 'INFORMATION',
    showRequiredFields: false,
    showDialog: false,
    ageIntervals: [
      { description: '0 a 18', holderCount: null, dependentCount: null, total: null },
      { description: '19 a 23', holderCount: null, dependentCount: null, total: null },
      { description: '24 a 28', holderCount: null, dependentCount: null, total: null },
      { description: '29 a 33', holderCount: null, dependentCount: null, total: null },
      { description: '34 a 38', holderCount: null, dependentCount: null, total: null },
      { description: '39 a 43', holderCount: null, dependentCount: null, total: null },
      { description: '44 a 48', holderCount: null, dependentCount: null, total: null },
      { description: '49 a 53', holderCount: null, dependentCount: null, total: null },
      { description: '54 a 58', holderCount: null, dependentCount: null, total: null },
      { description: '59 ou +', holderCount: null, dependentCount: null, total: null },
    ],
    ageIntervalsTotal: {
      sumHolderCount: null,
      sumDependentCount: null,
      sumTotal: null,
    },
    enumeratedAges: [],
  }),
  props: {
    showDialogLifes: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showDialogLifes(newValue) {
      this.msgDialogType = 'INFORMATION';
      this.showDialog = newValue; 
    },
    ageIntervals: {
      handler(newValue) {
        if(newValue) {
          this.ageIntervalsTotal.sumTotal = 0;
          this.ageIntervalsTotal.sumDependentCount = 0;
          this.ageIntervalsTotal.sumHolderCount = 0;
          this.ageIntervals.forEach(item => {
            const holderCount = item.holderCount && parseInt(item.holderCount) > 0 ? parseInt(item.holderCount): 0;
            const dependentCount = item.dependentCount && parseInt(item.dependentCount) > 0 ? parseInt(item.dependentCount) : 0;
            item.total = ((holderCount + dependentCount) > 0) ? holderCount + dependentCount : null;
            
            if(item.total && parseInt(item.total) > 0) {
              this.ageIntervalsTotal.sumTotal = this.ageIntervalsTotal.sumTotal + parseInt(item.total);
            }

            if(item.dependentCount && parseInt(item.dependentCount) > 0) {
              this.ageIntervalsTotal.sumDependentCount = this.ageIntervalsTotal.sumDependentCount + parseInt(item.dependentCount);
            }

            if(item.holderCount && parseInt(item.holderCount) > 0) {
              this.ageIntervalsTotal.sumHolderCount = this.ageIntervalsTotal.sumHolderCount + parseInt(item.holderCount);
            }
          });
          
          if(this.ageIntervalsTotal.sumTotal === 0) {
            this.ageIntervalsTotal.sumTotal = null;
          }

          if(this.ageIntervalsTotal.sumDependentCount === 0) {
            this.ageIntervalsTotal.sumDependentCount = null;
          }

          if(this.ageIntervalsTotal.sumHolderCount === 0) {
            this.ageIntervalsTotal.sumHolderCount = null;
          }
        }
        this.updateAgeInterval();
        this.updateAgeIntervalTotal();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations(['showmsg']),
    ...mapActions(['setAgeIntervalsObj', 'setEnumeratedAgesObj', 'setAgeIntervalsTotalObj']),
    clearFieds() {
      this.setAgeIntervalsObj(JSON.parse(JSON.stringify([])));
      this.setEnumeratedAgesObj(JSON.parse(JSON.stringify([])));
      
      this.ageIntervals.forEach(item => {
        item.holderCount = null;
        item.dependentCount = null;
        item.total = null;
      });
      
      this.ageIntervalsTotal = {
        sumHolderCount: null,
        sumDependentCount: null,
        sumTotal: null,
      };
      
      this.msgDialogType = 'INFORMATION';
      this.enumeratedAges = [];
    },
    updateAgeIntervalTotal() {
      this.setAgeIntervalsTotalObj(JSON.parse(JSON.stringify(this.ageIntervalsTotal)));
    },
    updateAgeInterval() {
      this.setAgeIntervalsObj(JSON.parse(JSON.stringify(this.ageIntervals)));
    },
    updateEnumeratedAges() {
      this.setEnumeratedAgesObj(JSON.parse(JSON.stringify(this.enumeratedAges)));
    },
    clearEnumeratedAges() {
      this.setEnumeratedAgesObj(JSON.parse(JSON.stringify([])));
    },
    closeDialog() {
      this.showDialog = false;
    },
    cancelDialog() {
      this.closeDialog();
      this.$emit('cancelDialogAndContinue', this.showDialog);
    },
    confirmDialog() {
      if(this.enumeratedAges && this.enumeratedAges.filter(item => !item.age).length) {
        this.msgDialogType = 'EMPTY';
      } else if(this.enumeratedAges && this.enumeratedAges.filter(item => item.age && parseInt(item.age) < 59).length) {
        this.msgDialogType = 'AGE';
      } else {
        this.msgDialogType = 'INFORMATION';
        this.updateEnumeratedAges();
        this.closeDialog();
        this.$emit('confirmDialogAndContinue', this.showDialog);
      }
    },
    reloadDataFromSessionStorage(onlyEnumerated = false) {
      if (sessionStorage.getItem(this.quoteSessionKey)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(this.quoteSessionKey)));
        if(!onlyEnumerated) {
          this.ageIntervals = quoteData && quoteData.ageIntervalsObj ? quoteData.ageIntervalsObj : this.ageIntervals;
          this.ageIntervalsTotal = quoteData && quoteData.ageIntervalsTotalObj ? quoteData.ageIntervalsTotalObj :  this.ageIntervalsTotal;
        } else {
          this.enumeratedAges = quoteData && quoteData.enumeratedAgesObj ? quoteData.enumeratedAgesObj : [];
          this.updateEnumeratedAges();
        }
      }
    },
    isEqualsEnumeratedAgesDatas() {
      if (sessionStorage.getItem(this.quoteSessionKey)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(this.quoteSessionKey)));
        const ageIntervalsSession = quoteData ? quoteData.ageIntervalsObj : null;
        
        return (ageIntervalsSession[ageIntervalsSession.length - 1].holderCount || ageIntervalsSession[ageIntervalsSession.length - 1].dependentCount)
          && ageIntervalsSession[ageIntervalsSession.length - 1].holderCount === this.ageIntervals[this.ageIntervals.length - 1].holderCount
          && ageIntervalsSession[ageIntervalsSession.length - 1].dependentCount === this.ageIntervals[this.ageIntervals.length - 1].dependentCount;
      }
      return false;
    }
  },
  computed: {
    getCountLifesFromDialog() {
      if(this.ageIntervals && this.ageIntervals[this.ageIntervals.length - 1] 
        && this.ageIntervals[this.ageIntervals.length - 1].total) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.enumeratedAges = [];
        
        const holderCount = this.ageIntervals[this.ageIntervals.length - 1].holderCount;
        if(holderCount && parseInt(holderCount) > 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.enumeratedAges = Array.from({length: holderCount}, (v, i) => ({
            description: `Titular ${i+1}`,
            age: null,
          }));
        }

        const dependentCount = this.ageIntervals[this.ageIntervals.length - 1].dependentCount;
        if(dependentCount && parseInt(dependentCount) > 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.enumeratedAges = this.enumeratedAges.concat(Array.from({length: dependentCount}, (v, i) => ({
            description: `Dependente ${i+1}`,
            age: null,
          })));
        }
        
        if(this.isEqualsEnumeratedAgesDatas()) {
          this.reloadDataFromSessionStorage(true);
        }
        return this.enumeratedAges;
      }
      return [];
    },
  },
  created() {
    this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');
    this.reloadDataFromSessionStorage();
  },
};
</script>

<style scoped>

.component-col-age {
  height: 45px !important;
}

.component-col {
  height: 62px !important;
}

.component-col-header {
  height: 25px !important;
  color: var(--v-foreground-base);
  font-weight: bold;
}

</style>
